export const SET_ACCOUNT_INFO = 'SetAccountInfo';
export const SET_MEMBER_LOOKUP = 'SetMemberLookup';
export const CLEAR_STATE = 'ClearState';
export const SET_REDEMPTION_SUMMARY = 'SetRedemptionSummary';
export const SET_REGISTER_CUSTOMER = 'SetRegisterCustomer';
export const SET_SUBMIT_REDEMPTION = 'SetSubmitRedemption';
export const SET_VOID_REDEMPTION = 'SetVoidRedemption';
export const SET_UNLINK_ACCOUNT_INFO = 'SetUnlinkAccountInfo';
